import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { Base64UrlService } from '../../../services/base64url.service';

@Component({
  selector: 'tt-stock-zone-menu',
  templateUrl: './stock-zone-menu.component.html',
  styleUrls: ['./stock-zone-menu.component.css']
})
export class StockZoneMenuComponent implements OnInit {
    stockZoneKeyno;

    public webPageName: string = this.stateService.getCurrentName();

    public encodedStockZone: string = this.base64.urlEncode(this.menu?.stockzone_keyno + '|' + this.menu?.filtervalue);

    public menu?: Menu;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private base64: Base64UrlService, private datatask: DataTaskService) {
        this.stockZoneKeyno = this.stateService.getStateParams()['stockzone_keyno'];
    }

    private async loadMenu() {
        if (!!this.stockZoneKeyno) {
            this.menu = (await this.datatask.Post(930, { stockzone_keyno: this.stockZoneKeyno }))[0];
        }
    }

    private loadGrid() {
        if (!!this.menu) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId(this.menu?.view_id)
                    .setLoadDataFunction({
                        method: this.menu?.p2_datatask_keyno,
                        parameters: this.menu
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true })
                    .setCustomToolbarButtons([{
                        name: 'stockzonemenu_add',
                        text: 'stockzonemenu_add',
                        func: () => {
                            this.stateService?.go('stocklocation', {
                                stockzone_keyno: this.menu?.stockzone_keyno,
                                stocklocation_keyno: '0'
                            });
                        },
                        icon: 'fas fa-plus',
                        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        translate: true
                    }]);
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    //public goToFunc(state: any) {
    //    switch (state) {
    //        case 'selectreport':
    //            this.stateService?.go('selectreport', {
    //                webpage_name: this.stateService.getCurrentName(),
    //                argtype: 'stockzone_keyno',
    //                argvalue: this.base64.urlEncode(this.menu?.stockzone_keyno + '|' + this.menu?.filtervalue)
    //            });
    //            break;
    //        default:
    //            break;
    //    }
    //}

    private async init() {
        await this.loadMenu();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    stockzone_keyno: number;
    stockzone_name: string;
    stockplace_id: string;
    stockplace_name: string;
    nbr_of_stocklocations: number;
    filtervalue: string;
    p2_datatask_keyno: number;
    view_id: string;
    isactive: number;
    warehouse_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockZoneMenu', {
//        templateUrl: 'views/components/views/stockZoneMenu/stockZoneMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'base64', 'stockZoneMenuService', 'ttGridFactory', function ($stateParams, stateService, utilityService, base64, stockZoneMenuService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockZoneKeyno = $stateParams.stockzone_keyno;

//            vm.model = {
//                menu: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setCustomToolbarButtons([{
//                name: 'stockzonemenu_add',
//                text: 'stockzonemenu_add',
//                func: function () {
//                    stateService.go('stocklocation', {
//                        stockzone_keyno: vm.model.menu.stockzone_keyno,
//                        stocklocation_keyno: '0'
//                    });
//                },
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await stockZoneMenuService.getStockZoneMenu({ stockzone_keyno: stockZoneKeyno }))[0];

//                return loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.menu.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.menu.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.menu.p2_datatask_keyno) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.menu.p2_datatask_keyno,
//                        parameters: vm.model.menu
//                    };
//                }

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'selectreport':
//                        let encodedStockZone = base64.urlencode(vm.model.menu.stockzone_keyno + '|' + vm.model.menu.filtervalue);

//                        go({
//                            webpage_name: stateService.getCurrentName(),
//                            argtype: 'stockzone_keyno',
//                            argvalue: encodedStockZone
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
